// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1cCU5","title":"Images90_title__N0VWm","images":"Images90_images__2TOoS"};